import { NameOnEnvelopeEventName } from '../../../context/analytics-context/analytics-context-types';
import { AddressForm, AddressTypeCode } from '../../../global-types/addresses';

export const trackSubmittedNameOnEnvelope = (
  address: Pick<AddressForm, 'address_type_code' | 'display_name'>,
  isDisplayNameEnabled: boolean,
  track: (eventName: NameOnEnvelopeEventName, isPopulated: boolean) => void,
) => {
  if (!isDisplayNameEnabled) return;

  if (address.address_type_code === AddressTypeCode.SENDER) {
    track('return-address', Boolean(address.display_name?.trim()));
  } else if (address.address_type_code === AddressTypeCode.RECIPIENT) {
    track('recipient-address', Boolean(address.display_name?.trim()));
  }
};
